import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize from 'rehype-sanitize'
import styles from './timeline.module.scss'

function Timeline({ version, content }: { version: string; content: string }) {
    const [collapsed, setCollapsed] = useState(false)
    if (content && version) {
        return (
            <div className={styles.timelineBox}>
                <div className={styles.timeline} />
                <h1
                    onClick={() => setCollapsed(!collapsed)}
                    className={styles.changeLogArrow}
                >
                    <img src="/icons/arrow-purple.png" alt=">" className={styles.arrow + ' ' + (collapsed && styles.rotated)} />
                </h1>

                <div className={styles.content}>
                    <h2 className={styles.versionTitle}>{version}</h2>
                    {!collapsed ? (
                        <div className={styles.readmeContent}>
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                rehypePlugins={[rehypeRaw, rehypeSanitize]}
                            >
                                {content}
                            </ReactMarkdown>
                        </div>
                    ) : null}
                </div>
            </div>
        )
    } else {
        return null
    }
}

export default Timeline
